export const preventRouteRepeatOnPush = (route, history) => {
    if (document.location.pathname !== route){
        history.push(route)
    }
}